import { format, isToday } from "date-fns";
import { SyntheticEvent, useMemo, useRef, useState } from "react"
import { digToTimeString, getRandomIntInclusive } from "shared/helpers";
import { useDebounceCallback } from "shared/lib/debounce/useDebounce";

export const useAudioItem = () => {
  const audioElRef = useRef<HTMLAudioElement | null>(null);
  const lineRef = useRef<HTMLDivElement>(null);

  const [ isPlayed, setIsPlayed ] = useState<boolean>(false)

  const [ timeString, setTimeString ] = useState<string>('');
  const [ progressPrc, setProgressPrc ] = useState<number>(0);

  const when = useMemo(() => {
    const date = new Date(getRandomIntInclusive((new Date().getTime() - 2.592e+9), new Date().getTime()))

    if (isToday(date)) {
      const dateStr = format(date, 'HH:mm')

      return `Сегодня в ${dateStr}`
    } else {
      return format(date, 'dd.MM.yyyy в HH:mm')
    }
  }, [audioElRef])

  const onLoadedMetadata = (event: SyntheticEvent<HTMLAudioElement, Event>) => {
    const numDuration = event.currentTarget.duration;

    const strDuration = digToTimeString(numDuration);
    setTimeString(strDuration);
  }

  const onAudioPlay = () => {
    setIsPlayed(true);
  }

  const onAudioPause = () => {
    setIsPlayed(false);
  }

  const onAudioTimeUpdate = () => {
    if (!audioElRef.current) return;

    const currentTime = audioElRef.current.currentTime;
    const duration = audioElRef.current.duration;

    let prc = (currentTime / duration) * 100;
    if (prc > 100) prc = 100;
    if (prc < 0) prc = 0;
    setProgressPrc(prc);
  }

  //==========================================================================================

  const stopAllPlaying = () => {
    const audios: NodeListOf<HTMLAudioElement> = document.querySelectorAll('.hiveAudios audio');
    if (!audios.length) return;

    audios.forEach(e => e.pause());
  }

  const onPlayPauseButtonClick = () => {
    stopAllPlaying();
    if (!audioElRef.current) return;

    if (isPlayed) {
      audioElRef.current.pause();
      return;
    }

    audioElRef.current.play();
  }

  const setAudioCurrentTime = (prc: number) => {
    if (!audioElRef.current) return;
    const duration = audioElRef.current.duration;
    const newCurrentTime = (duration / 100) * prc;

    audioElRef.current.currentTime = newCurrentTime;
  }

  const setAudioCurrentTimeDebounced = useDebounceCallback(setAudioCurrentTime, 100);

  const onProgressInputChange = (e: any) => {
    setProgressPrc(e.target.value);
    setAudioCurrentTimeDebounced(e.target.value);
  }

  return {
    audioElRef,
    lineRef,
    isPlayed,
    timeString,
    when,
    progressPrc,
    onPlayPauseButtonClick,
    onLoadedMetadata,
    onAudioPlay,
    onAudioPause,
    onAudioTimeUpdate,
    setProgressPrc,
    onProgressInputChange
  }
}